import { TabContainer } from 'react-bootstrap';
import styled from 'styled-components';
import theme from '../../styles/theme';

export const VerticalTabContainer = styled(TabContainer)`
  .nav > li {
    text-align: end;

    &.active {
      background-color: #eee;
      border-right: 3px solid ${theme.colors.primary};
      font-weight: bold;
    }

    &:not(.active) > a:focus {
      background-color: #fff;
      outline: none;
    }
  }
`;
